import { render, staticRenderFns } from "./SaleHistoryEventSigned.vue?vue&type=template&id=2c3ddc5c&scoped=true"
import script from "./SaleHistoryEventSigned.vue?vue&type=script&lang=ts"
export * from "./SaleHistoryEventSigned.vue?vue&type=script&lang=ts"
import style0 from "./SaleHistoryEventSigned.vue?vue&type=style&index=0&id=2c3ddc5c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3ddc5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c3ddc5c')) {
      api.createRecord('2c3ddc5c', component.options)
    } else {
      api.reload('2c3ddc5c', component.options)
    }
    module.hot.accept("./SaleHistoryEventSigned.vue?vue&type=template&id=2c3ddc5c&scoped=true", function () {
      api.rerender('2c3ddc5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/SaleHistoryEventSigned.vue"
export default component.exports